class DocumentoProcessoDigitalUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlAssinarDocumentoEletronicamente(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/processo-digital/assinatura-eletronica`
	}

	getUrlAssinarDocumentoDigitalmente(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/processo-digital/assinatura-digital`
	}

	getUrlValidarDocumentoAssinado(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/processo-digital/assinatura/validar-documento-assinado`
	}

	getUrlJuntarDocumentoLote(idEntidadePai) {
		return `api/${this.PATH}/${idEntidadePai}/documentos/processo-digital/juntar/lote`
	}

	getUrlbuscarDocumentoPorId(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/processo-digital`
	}
}

export default DocumentoProcessoDigitalUrlBuilder
